/* VH home redesign (sections/vh-home-*.liquid). PRESENTATION ONLY.
   Motion and small UI state for the approved home preview. Reads only its own DOM (.vh-home roots), never customer
   or cart data, makes no network calls and adds no cart behavior: every price, button and product on the page is
   rendered by Liquid. Works without GSAP; the page is complete with JS off. */
(function () {
  if (window.VHHome) return;
  window.VHHome = true;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function cap(w) { w = String(w || ''); return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function withGsap(fn) {
    if (window.VHK && VHK.withGsap) return VHK.withGsap(fn);
    var tries = 0;
    (function wait() {
      if (window.gsap && window.ScrollTrigger) { try { gsap.registerPlugin(ScrollTrigger); } catch (e) {} fn(!RM); return; }
      if (++tries > 60) { fn(false); return; }
      setTimeout(wait, 50);
    })();
  }
  /* height of the store's sticky reward bar + header (CSS var --vh-top on our roots); measured, never written */
  var probe = null;
  function topOffset() {
    if (window.VHK && VHK.top) { var t = VHK.top(); if (t) return t; }
    var root = $('.vh-home');
    if (!root) return 0;
    if (!probe) { probe = document.createElement('i'); probe.setAttribute('aria-hidden', 'true'); probe.style.cssText = 'position:absolute;left:0;top:0;width:0;visibility:hidden;pointer-events:none;height:var(--vh-top,0px)'; root.appendChild(probe); }
    return probe.offsetHeight || 0;
  }
  var smoothTo = function (y) { window.scrollTo({top: y, behavior: RM ? 'auto' : 'smooth'}); };
  function mixHex(a, b, t) {
    var p = function (h) { h = String(h || '#000000').replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); return [0, 2, 4].map(function (k) { return parseInt(h.slice(k, k + 2), 16) || 0; }); };
    var A = p(a), B = p(b);
    return '#' + A.map(function (x, k) { return Math.round(x * t + B[k] * (1 - t)).toString(16).padStart(2, '0'); }).join('');
  }

  /* ---------- video modal (one per root that has videos) ---------- */
  function initVideo(root) {
    var modal = $('.vmodal', root);
    if (!modal) return;
    var v = $('video', modal), capEl = $('.mcap', modal), close = $('.vmodal-x', modal), opener = null;
    function shut() { v.pause(); v.removeAttribute('src'); v.load(); modal.hidden = true; if (opener) opener.focus(); }
    $$('[data-video]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        opener = b; v.src = b.getAttribute('data-video'); capEl.textContent = b.getAttribute('data-cap') || '';
        modal.hidden = false; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); close.focus();
      });
    });
    close.addEventListener('click', shut);
    modal.addEventListener('click', function (e) { if (e.target === modal) shut(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) shut(); });
  }

  /* ---------- 1. hero: shop by goal ---------- */
  var H = {goFam: null};
  function initHero(root, motion) {
    var goalsEl = $('.goals', root), goals = $$('.goal', root);
    if (!goals.length) return;
    var packs = $$('.packs', root), chips = $$('.chip', root), word = $('.bigword-t', root);
    var fw = $('.famline .fw', root), blurb = $('.famline p', root), shop = $('.hero-shop', root), shopT = $('.hero-shop-t', root);
    var cur = 0, auto = motion, progTw = null;
    function show(i) {
      var g = goals[i];
      packs.forEach(function (p, j) { p.classList.toggle('is-off', j !== i); });
      chips.forEach(function (c) { c.hidden = +c.getAttribute('data-i') !== i; });
      if (word) word.textContent = g.getAttribute('data-word');
    }
    function setGoal(i, user) {
      if (i === cur && !user) return;
      var g = goals[i], prev = cur;
      goals.forEach(function (b, j) { b.setAttribute('aria-checked', j === i ? 'true' : 'false'); });
      if (fw) fw.textContent = g.getAttribute('data-word') + ' · ' + g.getAttribute('data-hl');
      if (blurb) blurb.textContent = g.getAttribute('data-blurb');
      if (shopT) shopT.textContent = (root.dataset.i18nShop || 'Shop __NAME__').replace('__NAME__', cap(g.getAttribute('data-word')));
      if (shop) { shop.href = g.getAttribute('data-url'); shop.setAttribute('data-fam', String(i)); }
      if (g.getAttribute('data-accent')) root.style.setProperty('--accent', g.getAttribute('data-accent'));
      cur = i;
      if (i !== prev) {
        if (motion) {
          var oldImgs = $$('.pk img', packs[prev]), oldChip = chips.filter(function (c) { return !c.hidden; });
          gsap.to(oldImgs.concat(oldChip, word ? [word] : []), {y: 40, opacity: 0, duration: .32, stagger: .04, ease: 'power2.in', onComplete: function () {
            gsap.set(oldImgs.concat(oldChip, word ? [word] : []), {clearProps: 'all'});
            show(i);
            var nw = $$('.pk img', packs[i]), chip = chips.filter(function (c) { return !c.hidden; });
            if (word) gsap.fromTo(word, {opacity: 0}, {opacity: 1, duration: .8, ease: 'power3.out'});
            gsap.fromTo(nw, {y: -70, opacity: 0}, {y: 0, opacity: 1, duration: .9, stagger: .09, ease: 'back.out(1.4)'});
            if (chip.length) gsap.fromTo(chip, {y: 24, opacity: 0}, {y: 0, opacity: 1, duration: .6, delay: .25, ease: 'power3.out'});
          }});
        } else show(i);
      }
      if (user) stopAuto(); else if (auto) runProgress();
    }
    function runProgress() {
      if (!motion) return;
      var bars = $$('.prog', goalsEl);
      bars.forEach(function (p) { gsap.set(p, {width: 0}); });
      if (progTw) progTw.kill();
      progTw = gsap.to(bars[cur], {width: '100%', duration: 6, ease: 'none', onComplete: function () { if (auto) setGoal((cur + 1) % goals.length); }});
    }
    function stopAuto() { auto = false; if (progTw) progTw.kill(); $$('.prog', goalsEl).forEach(function (p) { p.style.width = 0; }); }
    goalsEl.addEventListener('click', function (e) { var b = e.target.closest('.goal'); if (b) setGoal(+b.getAttribute('data-i'), true); });
    goalsEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var n = (cur + (e.key === 'ArrowRight' ? 1 : goals.length - 1)) % goals.length;
      setGoal(n, true); goals[n].focus();
    });
    var stage = $('.stage', root);
    if (stage) {
      stage.addEventListener('mouseenter', function () { if (progTw) progTw.pause(); });
      stage.addEventListener('mouseleave', function () { if (auto && progTw) progTw.resume(); });
    }
    /* "Shop <family>": jump to that family's scene on this page (falls back to the collection link) */
    if (shop) shop.addEventListener('click', function (e) { if (H.goFam) { e.preventDefault(); H.goFam(+(shop.getAttribute('data-fam') || 0)); } });
    if (motion) {
      runProgress();
      gsap.to($$('.packs', root), {y: -10, duration: 3.2, yoyo: true, repeat: -1, ease: 'sine.inOut'});
      gsap.from([$('.hero-top', root), stage, $('.hero-copy', root)], {autoAlpha: 0, y: 34, duration: 1.1, stagger: .14, ease: 'power3.out', delay: .1});
    }
  }

  /* ---------- 4. families: the lineup (pinned scene) ---------- */
  function initFamilies(root, motion) {
    var fx = $('.fx', root);
    if (!fx) return;
    var scenes = $$('.fxf', fx), navBtns = $$('.fx-nav button', fx), famI = 0;
    if (!scenes.length) return;
    function famDot(i) {
      famI = i;
      navBtns.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      scenes.forEach(function (s, j) { s.classList.toggle('act', j === i); });
      fx.style.setProperty('--fcur', scenes[i].getAttribute('data-color'));
    }
    H.goFam = function (i) { var s = scenes[i]; if (s) smoothTo(s.getBoundingClientRect().top + window.scrollY - topOffset() - 24); };
    $('.fx-nav', fx).addEventListener('click', function (e) { var b = e.target.closest('button'); if (b && H.goFam) H.goFam(+b.getAttribute('data-i')); });
    if (!motion) return;
    var bar = $('.fx-bar', fx), bg = $('.fx-bg', fx);
    var mm = gsap.matchMedia();
    mm.add({desk: '(min-width: 901px)', mob: '(max-width: 900px)'}, function () {
      fx.classList.add('is-on');
      var imgsOf = function (k) { return $$('.fx-packs img', scenes[k]); };
      var wordOf = function (k) { return $('.fx-word span', scenes[k]); };
      var infoOf = function (k) { return $('.fx-info', scenes[k]); };
      var mob = window.innerWidth <= 900, N = scenes.length;
      /* the photos are 10:7 boxes; the pack itself fills about half the box width */
      var VIS = 0.5;
      var pos = function (el, kind, k) {
        var n = +el.getAttribute('data-n'), o = +el.getAttribute('data-j') - (n - 1) / 2, W = fx.clientWidth, Hh = fx.clientHeight;
        var sib = imgsOf(k), edge = Math.max.apply(null, sib.map(function (s) { return s.offsetWidth; })) * VIS * 1.12;
        var half = W * .4, steps = Math.max(1, (n - 1) / 2);
        var sp = Math.max(0, Math.min(W * (mob ? .15 : .115), 190, (half - edge / 2) / steps));
        if (kind === 'land') return {x: o * sp, y: Math.abs(o) * 10, rotation: o * 6, scale: 1, autoAlpha: 1};
        var side = o === 0 ? (k % 2 ? 1 : -1) : Math.sign(o);
        if (kind === 'in') return {x: side * W * (.45 + Math.abs(o) * .12), y: Hh * .55, rotation: side * (35 + Math.abs(o) * 12), scale: .7, autoAlpha: 0};
        return {x: side * W * (.4 + Math.abs(o) * .14), y: -Hh * (.5 + Math.abs(o) * .06), rotation: -side * (30 + Math.abs(o) * 15), scale: .7, autoAlpha: 0};
      };
      var v = function (kind, k) {
        return {xPercent: -50, x: function (i, el) { return pos(el, kind, k).x; }, y: function (i, el) { return pos(el, kind, k).y; },
          rotation: function (i, el) { return pos(el, kind, k).rotation; }, scale: function (i, el) { return pos(el, kind, k).scale; },
          autoAlpha: function (i, el) { return pos(el, kind, k).autoAlpha; }};
      };
      var bgc = scenes.map(function (s) { return mixHex(s.getAttribute('data-color'), '#06120c', .22); });
      scenes.forEach(function (s, k) {
        gsap.set(imgsOf(k), v(k ? 'in' : 'land', k));
        gsap.set(wordOf(k), k ? {yPercent: 60, clipPath: 'inset(100% 0% 0% 0%)'} : {yPercent: 0, clipPath: 'inset(0% 0% 0% 0%)'});
        gsap.set(infoOf(k), k ? {autoAlpha: 0, y: 30} : {autoAlpha: 1, y: 0});
      });
      gsap.set(bg, {backgroundColor: bgc[0]}); famDot(0);
      var tl = gsap.timeline({scrollTrigger: {trigger: fx, start: function () { return 'top ' + topOffset() + 'px'; }, end: function () { return '+=' + window.innerHeight * (mob ? 4 : 4.5); }, pin: true, scrub: 1, invalidateOnRefresh: true,
        onUpdate: function (st) { var t = st.progress * tl.duration(), k = Math.min(N - 1, Math.max(0, Math.floor((t + .3) / 2))); if (k !== famI) famDot(k); gsap.set(bar, {scaleX: st.progress}); }}});
      tl.set(imgsOf(0), v('land', 0), 0);
      for (var k = 1; k < N; k++) {
        var T = 2 * k - 1;
        tl.to(imgsOf(k - 1), Object.assign(v('out', k - 1), {duration: 1, stagger: .05, ease: 'power2.in'}), T)
          .to(wordOf(k - 1), {yPercent: -60, clipPath: 'inset(0% 0% 100% 0%)', duration: .8, ease: 'power2.in'}, T)
          .to(infoOf(k - 1), {autoAlpha: 0, y: -24, duration: .45, ease: 'power1.in'}, T)
          .to(bg, {backgroundColor: bgc[k], duration: 1.1, ease: 'none'}, T + .15)
          .fromTo(imgsOf(k), v('in', k), Object.assign(v('land', k), {duration: 1, stagger: .06, ease: 'power3.out'}), T + .4)
          .fromTo(wordOf(k), {yPercent: 60, clipPath: 'inset(100% 0% 0% 0%)'}, {yPercent: 0, clipPath: 'inset(0% 0% 0% 0%)', duration: .8, ease: 'power3.out'}, T + .35)
          .fromTo(infoOf(k), {autoAlpha: 0, y: 30}, {autoAlpha: 1, y: 0, duration: .5, ease: 'power2.out'}, T + .8);
      }
      tl.to({}, {duration: .4});
      H.goFam = function (i) { var st = tl.scrollTrigger, at = i ? 2 * i + .7 : .5; smoothTo(st.start + (st.end - st.start) * (at / tl.duration())); };
      gsap.from($('.fx-packs', scenes[0]), {y: 120, autoAlpha: 0, scale: .86, duration: 1.2, ease: 'power3.out', scrollTrigger: {trigger: fx, start: 'top 70%', once: true}});
      return function () {
        fx.classList.remove('is-on');
        gsap.set($$('.fx-packs img, .fx-packs, .fx-word span, .fx-info', fx).concat([bg, bar]), {clearProps: 'all'});
      };
    });
  }

  /* ---------- 5. top five: stacked cards ---------- */
  function initTop5(root, motion) {
    var cards = $$('.t5c', root), rail = $$('.t5-rail button', root), stack = $('.t5-stack', root);
    if (!cards.length) return;
    var t5Top = function (c) { return parseFloat(getComputedStyle(c).top) || 0; };
    function setRail(i) { rail.forEach(function (b, j) { b.setAttribute('aria-current', j === Math.max(0, i) ? 'true' : 'false'); }); }
    var railEl = $('.t5-rail', root);
    if (railEl) railEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var i = +b.getAttribute('data-i'), gap = parseFloat(getComputedStyle(stack).rowGap) || 0;
      smoothTo(stack.getBoundingClientRect().top + window.scrollY + i * (cards[0].offsetHeight + gap) - t5Top(cards[i]) + 2);
    });
    if (!motion) return;
    cards.forEach(function (c, k) {
      var img = $('.t5-media img', c);
      if (img) gsap.fromTo(img, {y: 90, rotate: 6}, {y: 0, rotate: -5, ease: 'none', scrollTrigger: {trigger: c, start: 'top bottom', end: function () { return 'top ' + t5Top(c) + 'px'; }, scrub: true, invalidateOnRefresh: true}});
      ScrollTrigger.create({trigger: c, start: function () { return 'top ' + (t5Top(c) + 2) + 'px'; }, invalidateOnRefresh: true, onEnter: function () { setRail(k); }, onLeaveBack: function () { setRail(k - 1); }});
      var next = cards[k + 1]; if (!next) return;
      var st = {trigger: next, start: function () { return 'top ' + (t5Top(c) + c.offsetHeight) + 'px'; }, end: function () { return 'top ' + t5Top(next) + 'px'; }, scrub: true, invalidateOnRefresh: true};
      gsap.to(c, {scale: .9, ease: 'none', scrollTrigger: st});
      gsap.to($('.shade', c), {opacity: .5, ease: 'none', scrollTrigger: Object.assign({}, st, {start: function () { return 'top ' + (t5Top(next) + c.offsetHeight * .3) + 'px'; }})});
    });
  }

  /* ---------- 6. reviews marquee ---------- */
  function initReviews(root, motion) {
    if (!motion) return;
    $$('.marq', root).forEach(function (el, i) {
      var dir = i % 2 ? 1 : -1, half = function () { return el.scrollWidth / 2; };
      var tw = gsap.fromTo(el, {x: dir < 0 ? 0 : -half()}, {x: dir < 0 ? -half() : 0, duration: 60, ease: 'none', repeat: -1});
      el.addEventListener('mouseenter', function () { tw.pause(); }); el.addEventListener('mouseleave', function () { tw.resume(); });
    });
  }

  /* ---------- 7. three ways: the price odometer ---------- */
  function initWays(root, motion) {
    var odo = $('.odo', root), price = $('.odo-price', root), card = $('.odo-card', root);
    if (!odo || !price) return;
    var a = price.getAttribute('data-a') || '', b = price.getAttribute('data-b') || '';
    var steps = $$('.odo-steps li', root);
    function setStep(i) { steps.forEach(function (li, j) { li.classList.toggle('is-on', j === i); }); card.classList.toggle('flipped', i === 2); }
    if (!motion) return;
    /* each digit is a strip of 0-9 twice; --c picks the cell, so tweening --c rolls it like an odometer.
       The text is the theme's formatted price (Liquid); only its digits are animated. */
    var same = b && a.length === b.length;
    var esc = function (ch) { return ch.replace(/&/g, '&amp;').replace(/</g, '&lt;'); };
    var plain = function (t) { return t.split('').map(function (ch) { return '<span class="ch">' + esc(ch) + '</span>'; }).join(''); };
    var shown = a;
    /* the rolling digits exist only while the animation runs (desktop); everywhere else the price stays plain text.
       Fix 2026-10-13: the cleanup used to clearProps the digit columns, which removed --c and showed $0.00 */
    var rolls = function () { return a.split('').map(function (ch, i) {
      if (same && /\d/.test(ch) && /\d/.test(b[i])) {
        var cells = ''; for (var k = 0; k < 20; k++) cells += '<span>' + (k % 10) + '</span>';
        return '<span class="col" data-b="' + b[i] + '" style="--c:' + ch + '">' + cells + '</span>';
      }
      return '<span class="ch">' + esc(ch) + '</span>';
    }).join(''); };
    var mm = gsap.matchMedia();
    /* desktop only: on phones the pinned stage (heading + card + three steps) is taller than the screen under the header,
       so it was cut off at the top and covered by the floating buttons; phones get the plain stacked cards */
    mm.add({desk: '(min-width: 901px)'}, function () {
      odo.classList.add('is-on');
      shown = a; price.innerHTML = rolls();
      var cols = $$('.col', price);
      var ot = gsap.timeline({scrollTrigger: {trigger: odo, start: function () { return 'top ' + topOffset() + 'px'; }, end: function () { return '+=' + window.innerHeight * 2.2; }, pin: true, scrub: 1, invalidateOnRefresh: true,
        onUpdate: function (st) {
          var t = st.progress * ot.duration(); setStep(t < 1.45 ? 0 : t < 3.4 ? 1 : 2);
          /* prices of different lengths cannot roll digit by digit: switch the text instead */
          if (!same && b) { var want = t >= 1.5 ? b : a; if (want !== shown) { shown = want; price.innerHTML = plain(want); } }
        }}});
      if (cols.length) ot.to(cols, {'--c': function (i, el) { return +el.getAttribute('data-b') + 10; }, duration: 1, ease: 'power2.inOut', stagger: .06}, 1);
      ot.to($$('.odo-a', root), {autoAlpha: 0, y: -12, duration: .3}, 1.05)
        .fromTo($$('.odo-b', root), {autoAlpha: 0, y: 12}, {autoAlpha: 1, y: 0, duration: .3}, 1.45)
        .to(card, {rotationY: 180, duration: 1, ease: 'power2.inOut'}, 3)
        .to({}, {duration: .5});
      return function () {
        odo.classList.remove('is-on');
        gsap.set([card].concat($$('.odo-a, .odo-b', root)), {clearProps: 'all'});
        shown = a; price.innerHTML = plain(a);
      };
    });
  }

  /* ---------- 8. how it works ---------- */
  function initHow(root, motion) {
    var how = $('.how', root), stage = $('.how-stage', root);
    if (!how || !stage) return;
    var steps = $$('.steps .how-step', root), scr = $$('.p-you .scr', root);
    function setStep(i) {
      stage.setAttribute('data-step', i);
      steps.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
      scr.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
    }
    steps.forEach(function (s, i) { s.addEventListener('click', function () { setStep(i); }); });
    how.classList.add('is-js');
    if (!motion) return;
    var mm = gsap.matchMedia();
    /* desktop: pinned, scroll walks the 3 steps. Phones (2026-10-13): pinning squeezed the phones to whatever height was
       left under the header (text broke apart, steps under the floating buttons), so phones scroll normally and the
       steps advance on their own while the section is on screen (a tap on a step still picks it). */
    mm.add({desk: '(min-width: 1001px)'}, function () {
      var stepI = 0;
      ScrollTrigger.create({trigger: how, start: function () { return 'top ' + topOffset() + 'px'; }, end: function () { return '+=' + window.innerHeight * 1.4; }, pin: true, invalidateOnRefresh: true,
        onUpdate: function (st) { var i = Math.min(2, Math.floor(st.progress * 2.999)); if (i !== stepI) { stepI = i; setStep(i); } }});
    });
    mm.add({mob: '(max-width: 1000px)'}, function () {
      /* phones: pinned like desktop, but sized to the real screen. The section gets exactly the height left under the
         header; only the current step card shows; the phones (600px design size) are zoomed so heading + phones + card
         fit above the floating Change Market / VIA buttons (FLOAT). Re-measured on every refresh/resize. */
      var FLOAT = 84, head = $('.sec-head', how), stepI = 0;
      how.classList.add('is-pin');
      function fit() {
        var h = window.innerHeight - topOffset();
        how.style.height = h + 'px';
        var tallest = 0;
        steps.forEach(function (s) { var d = s.style.display; s.style.display = 'grid'; tallest = Math.max(tallest, s.offsetHeight); s.style.display = d; });
        var room = h - FLOAT - (head ? head.offsetHeight : 0) - tallest - 3 * 12 - 16;
        stage.style.setProperty('--how-z', Math.max(.3, Math.min(.62, room / 600)).toFixed(3));
      }
      fit();
      var st = ScrollTrigger.create({trigger: how, start: function () { return 'top ' + topOffset() + 'px'; }, end: function () { return '+=' + window.innerHeight * 1.4; }, pin: true, invalidateOnRefresh: true,
        onRefreshInit: fit,
        onUpdate: function (st) { var i = Math.min(2, Math.floor(st.progress * 2.999)); if (i !== stepI) { stepI = i; setStep(i); } }});
      return function () { st.kill(); how.classList.remove('is-pin'); how.style.height = ''; stage.style.removeProperty('--how-z'); setStep(0); };
    });
  }

  /* ---------- 9. stories ---------- */
  function initStories(root, motion) {
    var items = $$('.qitem', root), dots = $$('.qdots button', root);
    if (items.length < 2) return;
    var qi = 0, qT = null;
    function setQ(i) {
      qi = (i + items.length) % items.length;
      items.forEach(function (q, j) { q.classList.toggle('is-on', j === qi); });
      dots.forEach(function (b, j) { b.setAttribute('aria-current', j === qi ? 'true' : 'false'); });
    }
    var prev = $('.q-prev', root), next = $('.q-next', root), dotsEl = $('.qdots', root);
    if (prev) prev.addEventListener('click', function () { setQ(qi - 1); clearInterval(qT); });
    if (next) next.addEventListener('click', function () { setQ(qi + 1); clearInterval(qT); });
    if (dotsEl) dotsEl.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) { setQ(+b.getAttribute('data-i')); clearInterval(qT); } });
    if (!RM) qT = setInterval(function () { setQ(qi + 1); }, 7000);
    if (motion && $('.collage', root)) {
      [['.collage .a', -50], ['.collage .b', 40], ['.collage .c', -20]].forEach(function (d) {
        var el = $(d[0], root); if (el) gsap.fromTo(el, {y: -d[1]}, {y: d[1], ease: 'none', scrollTrigger: {trigger: $('.collage', root), start: 'top bottom', end: 'bottom top', scrub: true}});
      });
    }
  }

  /* every section after the hero fades and rises in as it arrives */
  function reveals(motion) {
    if (!motion) return;
    /* 2026-10-02 perf: IntersectionObserver + CSS (VHK.revealIO) instead of a ScrollTrigger per element */
    var els = $$('.vh-home .revs .sec-head, .vh-home .marq-row, .vh-home .revs-note, .vh-home .t5-side, .vh-home .collage, .vh-home .quote, .vh-home .fsplit');
    if (window.VHK && VHK.revealIO) { VHK.revealIO(els, 56); return; }
    els.forEach(function (el) {
      gsap.fromTo(el, {autoAlpha: 0, y: 56}, {autoAlpha: 1, y: 0, duration: 1.2, ease: 'power3.out', scrollTrigger: {trigger: el, start: 'top 88%', once: true}});
    });
  }

  /* Square store photos are requested cropped to 10:7 (snippets/vh-home-img.liquid), which assumes ~16% empty space
     above and below the product. A photo without it (Global's 2026-10-07 V-Tedetox: the bag fills 98%) would lose its
     top and bottom, so each square photo's small probe is measured once and, if the crop would cut more than a sliver
     of product, the whole photo is shown fitted in the same 10:7 box instead (.vh-home-fit). Photos only. */
  var CROP_LOSS_MAX = 0.05;
  /* px = RGBA bytes of the whole photo (w x h); returns the share of its height the centered 10:7 crop cuts off product */
  function cropLoss(px, w, h) {
    var bg = [px[0], px[1], px[2], px[3]], clear = bg[3] < 16;
    function rowHas(y) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        if (clear ? px[i + 3] > 16 : (Math.abs(px[i] - bg[0]) + Math.abs(px[i + 1] - bg[1]) + Math.abs(px[i + 2] - bg[2]) > 48)) return true;
      }
      return false;
    }
    var top = 0, bot = 0;
    while (top < h && !rowHas(top)) top++;
    if (top >= h) return 0;
    while (!rowHas(h - 1 - bot)) bot++;
    var band = 0.15;
    return Math.max(0, band - top / h) + Math.max(0, band - bot / h);
  }
  function fitUncroppable() {
    var memo = {};
    function measure(url) {
      if (memo[url]) return memo[url];
      memo[url] = new Promise(function (done) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var w = im.naturalWidth, h = im.naturalHeight, c = document.createElement('canvas');
            c.width = w; c.height = h;
            var g = c.getContext('2d'); g.drawImage(im, 0, 0);
            done(cropLoss(g.getImageData(0, 0, w, h).data, w, h));
          } catch (e) { done(0); }
        };
        im.onerror = function () { done(0); };
        im.src = url;
      });
      return memo[url];
    }
    $$('.vh-home img[data-vh-probe]').forEach(function (img) {
      measure(img.getAttribute('data-vh-probe')).then(function (loss) {
        if (loss <= CROP_LOSS_MAX) return;
        img.removeAttribute('srcset');
        img.src = img.getAttribute('data-vh-whole');
        img.classList.add('vh-home-fit');
      });
    });
  }

  ready(function () {
    var roots = $$('.vh-home[data-vh-home]');
    if (!roots.length) return;
    fitUncroppable();
    roots.forEach(initVideo);
    withGsap(function (ok) {
      var motion = !!ok && !RM;
      if (motion) { try { ScrollTrigger.config({ignoreMobileResize: true}); } catch (e) {} }
      /* in page order, so pinned sections measure each other correctly */
      roots.forEach(function (root) {
        var part = root.getAttribute('data-vh-home');
        try {
          if (part === 'shop') { initHero(root, motion); initFamilies(root, motion); }
          else if (part === 'top5') initTop5(root, motion);
          else if (part === 'reviews') initReviews(root, motion);
          else if (part === 'ways') initWays(root, motion);
          else if (part === 'how') initHow(root, motion);
          else if (part === 'stories') initStories(root, motion);
        } catch (e) { if (window.console) console.warn('vh-home', part, e); }
      });
      reveals(motion);
      if (motion) {
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { (window.VHK && VHK.refresh ? VHK.refresh() : ScrollTrigger.refresh()); });
        /* window load: ScrollTrigger refreshes itself on load (autoRefreshEvents), no second pass */
      }
    });
  });
})();
